import { StripePayload, StripeResponse } from "api/types";
import customAxios from "config";
import { renterError } from "utils/errorMessage";

export const CreateStripeVerification = async (
  payload: StripePayload
): Promise<{ data?: StripeResponse; error?: string }> => {
  try {
    const response = await customAxios.post<StripeResponse>(
      "/api/identity/create_verification_session/",
      payload
    );
    return response;
  } catch (error) {
    return { error: renterError(error, "payment") };
  }
};

export const CreateStripeIntent = async (
  payload: any
): Promise<{ data?: any; error?: string }> => {
  try {
    const response = await customAxios.post<any>(
      "/api/payment/create_payment_intent/",
      payload
    );
    return response;
  } catch (error) {
    return { error: renterError(error, "payment") };
  }
};

export const SavePaymentMethod = async (
  payload: any
): Promise<{ data?: any; error?: string }> => {
  try {
    const response = await customAxios.post<any>(
      "/api/payment/manage-payment-method/",
      payload
    );
    return response;
  } catch (error) {
    return { error: renterError(error, "payment") };
  }
};

export const PaymentDone = async (
  payment_method: any,
  bookingId: any,
  partial_payment: boolean = false
): Promise<{ data?: any; error?: string }> => {
  const payload = {
    payment_method_id: payment_method,
    booking_id: bookingId,
    // 1NOW-649 — when true the backend charges only the policy deposit now and
    // schedules the balance; omitted/false preserves full-payment behaviour.
    partial_payment: partial_payment,
  };

  try {
    const response = await customAxios.post<any>(
      "/api/payment/charge-payment/",
      payload
    );

    return { data: response.data };
  } catch (error: any) {
    // This is the charge itself — the single place a renter most needs to know
    // what happened and whether they were billed. It previously returned the
    // raw server string, or `undefined` when the response carried no `error`
    // key, which surfaced as a blank failure at the end of checkout.
    return { error: renterError(error, "payment") };
  }
};

export const getSavedPaymentMethod = async (): Promise<any> => {
  try {
    const response = await customAxios.get<any>(
      "/api/payment/manage-payment-method/"
    );
    return response.data;
  } catch (error) {
    return { error: renterError(error, "payment") };
  }
};

export const removeSavedPaymentMethod = async (
  payment_method_id: string
): Promise<any> => {
  try {
    const response = await customAxios.delete<any>(
      "/api/payment/manage-payment-method/",
      {
        data: {
          payment_method_id: payment_method_id, // Sending the ID in the request body
        },
      }
    );
    return response.data;
  } catch (error) {
    return { error: renterError(error, "payment") };
  }
};

export const CreateVouchVerification = async (
  payload: StripePayload
): Promise<{ data?: StripeResponse; error?: string }> => {
  try {
    const response = await customAxios.post<StripeResponse>(
      "/api/vouched/create_verification_session/",
      payload
    );
    return response;
  } catch (error) {
    return { error: renterError(error, "payment") };
  }
};
